//AWS Mobile Project Constants for oak Thu Feb 27 12:56:06 EST 2020
import awsConfiguration from './aws-exports';

export default awsConfiguration;
